import axios from "axios";

const BASE_URL = 'https://consultaprocesos.ramajudicial.gov.co:448/api/v2'  // Producción
//const BASE_URL = "https://consultaprocesos.ramajudicial.gov.co:449/api/v2"  // Preproducción
//git const BASE_URL = 'https://localhost:44365/api/v2'  // Desarrollo
//const BASE_URL = 'http://localhost:5000/api/v2'  // Desarrollo
//const BASE_URL = 'https://S0001-VMCPAP01:449/api/v2'  // Ambiente de Pruebas

export default axios.create({
  baseURL: BASE_URL,
  timeout: 50000,
});


